export const GET_NOTIFICATIONS_LIST = 'GET_NOTIFICATIONS_LIST';
export const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS';
export const GET_NOTIFICATIONS_LIST_ERROR = 'GET_NOTIFICATIONS_LIST_ERROR';

export const SET_READ = 'SET_READ';
export const SET_READ_SUCCESS = 'SET_READ_SUCCESS';
export const SET_READ_ERROR = 'SET_READ_ERROR';